import "react-awesome-slider/dist/styles.css";

import { CustomButton, Dropdown } from "./index";
import { Image, Text, View, TouchableOpacity, StyleSheet } from "react-native";
import React, { useState, useRef, useEffect } from "react";
import { SimpleLineIcons } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import AwesomeSlider from "react-awesome-slider";
import { THEME_COLORS } from "../styles";
import ZoomMedia from "@screen/v3/BudgetModule/components/ZoomMedia";
interface IImageAlbumProps {
  images: { url: string; label?: string }[];
}

const Carousel = ({ showAlbum, setShowAlbum, images, openZoomImage }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentIndexRef = useRef(0);
  const imagesRef = useRef(null);

  useEffect(() => {
    imagesRef.current = images?.length;
  }, [images]);

  const goToNext = () => {
    currentIndexRef.current = currentIndexRef.current + 1;
    if (currentIndexRef.current > imagesRef.current - 1)
      currentIndexRef.current = 0;

    setCurrentIndex(currentIndexRef.current);
  };

  const goToPrev = () => {
    currentIndexRef.current = currentIndexRef.current - 1;
    if (currentIndexRef.current < 0)
      currentIndexRef.current = imagesRef.current - 1;

    setCurrentIndex(currentIndexRef.current);
  };

  useEffect(() => {
    const keyDownEvent = (event) => {
      if (event.key === "ArrowRight") {
        goToNext();
      } else if (event.key === "ArrowLeft") {
        goToPrev();
      }
    };
    document.addEventListener("keydown", keyDownEvent);
    return () => {
      document.removeEventListener("keydown", keyDownEvent);
    };
  }, []);

  const renderButtonRight = (
    <TouchableOpacity onPress={goToNext}>
      <SimpleLineIcons name="arrow-right" size={40} color={"#FFFFFF"} />
    </TouchableOpacity>
  );

  const renderButtonLeft = (
    <TouchableOpacity onPress={goToPrev}>
      <SimpleLineIcons name="arrow-left" size={40} color={"#FFFFFF"} />
    </TouchableOpacity>
  );

  const onTransitionRequest = (val) => {
    currentIndexRef.current = val?.nextIndex;
    setCurrentIndex(currentIndexRef.current);
  };

  return (
    <Dropdown
      show={showAlbum}
      onClose={() => {
        currentIndexRef.current = 0;
        setCurrentIndex(currentIndexRef.current);
        setShowAlbum(false);
      }}
      parentRef={null}
    >
      <View
        style={{
          minWidth: "65vw",
          position: "relative",
          alignContent: "center",
          height: "50vw",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <AwesomeSlider
          selected={currentIndex}
          onTransitionRequest={onTransitionRequest}
          infinite={images?.length > 1 ? true : false}
          buttonContentRight={renderButtonRight}
          buttonContentLeft={renderButtonLeft}
          organicArrows={false}
        >
          {images.map((obj, index) => {
            return (
              <View
                style={{
                  alignContent: "center",
                  flexDirection: "row",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <img
                  src={obj.url}
                  style={{
                    width: "auto",
                    height: "auto",
                    maxHeight: "-webkit-fill-available",
                    objectFit: "contain",
                  }}
                />
                <View style={styles.iconCon}>
                  {obj?.label ? (
                    <Text
                      style={{
                        backgroundColor: THEME_COLORS.bgWhite,
                        paddingHorizontal: 5,
                        paddingVertical: 2,
                      }}
                    >
                      {obj.label}
                    </Text>
                  ) : null}
                  {obj.mediaType !== "VIDEO" ? (
                    <TouchableOpacity
                      style={styles.zoomBtn}
                      onPress={() => openZoomImage("open", obj.url)}
                    >
                      <MaterialCommunityIcons
                        name="fullscreen"
                        size={25}
                        color={THEME_COLORS.white}
                      />
                    </TouchableOpacity>
                  ) : null}
                </View>
              </View>
            );
          })}
        </AwesomeSlider>
      </View>
    </Dropdown>
  );
};

const ImageAlbum = (props: IImageAlbumProps) => {
  const { images } = props;
  const [showAlbum, setShowAlbum] = useState(false);
  const [viewZoom, setViewZoom] = React.useState(false);
  const zoomUri = useRef(null);

  const isMoreThanOneImage = images.length > 1;
  const isImageExists = images.length > 0;

  const openZoomImage = (action, url) => {
    if (action === "open") setViewZoom(true);
    else setViewZoom(false);
    zoomUri.current = url;
  };

  return (
    <>
      <CustomButton
        text={`${images.length} Image${isMoreThanOneImage ? "s" : ""}`}
        disabled={!isImageExists}
        disableButtonStyle={true}
        textColor={THEME_COLORS.black2}
        style={{ paddingVertical: 0, height: null }}
        iconFileNameInAssets={"photo-album-icon.png"}
        iconHeight={24}
        iconWidth={24}
        onPress={() => {
          setShowAlbum(true);
        }}
      />
      {showAlbum ? (
        <Carousel
          showAlbum={showAlbum}
          openZoomImage={openZoomImage}
          setShowAlbum={setShowAlbum}
          images={images}
        />
      ) : null}
      {viewZoom ? (
        <ZoomMedia
          open={viewZoom}
          setOpen={(arg) => setViewZoom(arg)}
          imageUri={zoomUri.current}
        />
      ) : null}
    </>
  );
};

export default ImageAlbum;

const styles = StyleSheet.create({
  zoomBtn: {
    width: 40,
    height: 40,
    borderRadius: 40,
    marginLeft: 20,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#3030304D",
  },
  iconCon: {
    position: "absolute",
    bottom: 20,
    right: 40,
    flexDirection: "row",
    alignItems: "center",
  },
});
